import { useMemo, useCallback, useEffect, type ReactNode } from 'react';

import { useWallet } from 'hooks/useWallet';
import { TransactionService, sharedRpcClient } from 'services';
import { bindCsprClick } from 'services/rpcClient';
import type { ICsprCloudProxy } from '@make-software/csprclick-core-types';

import { ServicesContext } from './ServicesContext';

export const ServicesProvider = ({ children }: { children: ReactNode }) => {
  const { clickRef, isClickLoaded } = useWallet();

  // Casper node reads go through CSPR.click's proxy, read per request from the loaded SDK.
  useEffect(() => {
    bindCsprClick(clickRef);
  }, [clickRef]);

  // Get CSPR.cloud proxy for authenticated API requests
  const getCsprCloudProxy = useCallback((): ICsprCloudProxy | null => {
    return clickRef?.getCsprCloudProxy() || null;
  }, [clickRef]);

  const services = useMemo(
    () => ({
      transactionService: new TransactionService(sharedRpcClient, clickRef),
      getCsprCloudProxy,
      isClickLoaded,
    }),
    [clickRef, getCsprCloudProxy, isClickLoaded]
  );

  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
};
